import { render, staticRenderFns } from "./TelesalesDialog.vue?vue&type=template&id=318e7844&scoped=true"
import script from "./TelesalesDialog.vue?vue&type=script&lang=js"
export * from "./TelesalesDialog.vue?vue&type=script&lang=js"
import style0 from "./TelesalesDialog.vue?vue&type=style&index=0&id=318e7844&prod&lang=scss&scoped=true"
import style1 from "./TelesalesDialog.vue?vue&type=style&index=1&id=318e7844&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318e7844",
  null
  
)

export default component.exports